<template>
  <v-card :elevation="0">
    <v-toolbar flat color="transparent">
      <v-toolbar-title>{{
        this.$Amplify.I18n.get("Mis CPC's")
      }}</v-toolbar-title>
      <v-divider class="mx-2" inset vertical></v-divider>
      <v-spacer></v-spacer>
      <v-btn text icon @click.stop="refresh" color="secondary">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </v-toolbar>

    <v-alert
      v-if="alert.message"
      v-model="alert.show"
      prominent
      dense
      dismissible
      :type="alert.type || 'error'"
      transition="scale-transition"
    >
      <v-layout align-center wrap>
        <div>
          {{ alert.message }}
        </div>
      </v-layout>
    </v-alert>

    <v-card-text class="ma-0 pa-0">
      <!-- <span v-if="filters.length > 0" class="subheading hidden-sm-and-down"> Tiene {{filters.length}} filtro{{filters.length>1?"s":""}}</span>
      <span v-else class="subheading hidden-sm-and-down"> No tiene filtros</span>  -->

      <v-simple-table>
        <thead>
          <tr>
            <th class="text-center" style="width:40px">No.</th>
            <th class="text-center" style="width:80px">Código</th>
            <th class="text-left">Descripción</th>
          </tr>
        </thead>

        <tbody>
          <tr v-for="(item, index) in misCpcs" :key="item.cpc">
            <td class="text-center">
              {{ index + 1 }}
            </td>
            <td class="text-center">
              <v-chip outlined>{{ item.cpc }}</v-chip>
            </td>
            <td class="caption">
              <strong>Categoría:</strong> {{ item.categoria }} <br />
              <span class="font-weight-light">{{ item.descripcion }} </span>
            </td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "MisCpcs",
  components: {},
  data() {
    return {
      alert: {
        show: false,
        type: "",
        message: ""
      },
      error: "",
      logger: {}
    };
  },
  computed: {
    ...mapGetters(["misCpcs"])
  },
  watch: {},
  methods: {
    refresh: async function() {}
  },
  mounted() {
    this.logger = new this.$Amplify.Logger(this.$options.name);
  }
};
</script>
